import React, { useState, useEffect } from "react";
import { IconButton, Box, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { likePublication } from "../api/api";
import { userId } from "../services/AuthService";
import "./LikeButton.css";

const LikeButton = ({ post, updatePostLikes }) => {
  const [liked, setLiked] = useState(Array.isArray(post.likes) && post.likes.includes(userId));
  const [likes, setLikes] = useState(Array.isArray(post.likes) ? post.likes.length : 0);
  const [isLoading, setIsLoading] = useState(false);

  const toggleLike = async () => {
    const token = localStorage.getItem("authToken");

    // Store the current state before the update
    const prevLiked = liked;
    const prevLikes = likes;

    // Optimistic UI update: Immediately toggle the like state and count
    const newLikedState = !liked;
    const newLikesCount = newLikedState ? likes + 1 : likes - 1;

    setLiked(newLikedState);
    setLikes(newLikesCount);

    // Optimistically update the parent state via the callback
    updatePostLikes(post._id, newLikedState ? 1 : -1, newLikesCount);

    setIsLoading(true);

    try {
      const response = await likePublication(post._id, token);
      const data = await response.json();

      if (!response.ok) {
        // If server returns an error, revert the optimistic UI changes
        setLiked(prevLiked);
        setLikes(prevLikes);
        // Revert parent state update if necessary
        updatePostLikes(post._id, prevLiked ? 1 : -1, prevLikes);
      }
    } catch (error) {
      console.error("Error liking post:", error);
      // In case of error, revert the optimistic update
      setLiked(prevLiked);
      setLikes(prevLikes);
      // Revert parent state update if necessary
      updatePostLikes(post._id, prevLiked ? 1 : -1, prevLikes);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box style={{ display: "flex", alignItems: "center" }}>
      <IconButton
        onClick={toggleLike}
        className={liked ? "liked" : "unliked"}  // Dynamically add class
        disabled={isLoading}
      >
        {liked ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      </IconButton>
      <Typography>{likes}</Typography>
    </Box>
  );
};

export default LikeButton;
